import { useMemo, useEffect } from "react";
import { usePersistentState } from "../../../../Common/hooks/usePersistentState";
import { computeTextHash } from "../../../../Common/utils/hashUtils";
import { SettingsKeys } from "../../../../Common/models/storageSettingsKeys";

interface BannerDismissState {
  dismissed: boolean;
  lastTextHash: string;
}

export function useBannerDismiss(id: string, text: string, isActive: boolean) {
  const textHash = useMemo(() => computeTextHash(text), [text]);

  const storageKey = `${SettingsKeys.Banner}:${id}`;
  const [state, setState] = usePersistentState<BannerDismissState>(
    localStorage,
    storageKey,
    { dismissed: false, lastTextHash: textHash }
  );

  // Re-open when text changes
  useEffect(() => {
    if (state.lastTextHash !== textHash) {
      setState({ dismissed: false, lastTextHash: textHash });
    }
  }, [textHash, state.lastTextHash, setState]);

  const open = isActive && !state.dismissed;

  const dismiss = () => {
    setState({ dismissed: true, lastTextHash: textHash });
    window.dispatchEvent(new Event("bannerconfig:invalidate"));
  };

  const reset = () => setState({ dismissed: false, lastTextHash: textHash });

  return { open, dismiss, reset };
}
